import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import MaterialSpinner from "../../../../ui/materialSpinner";
import LookVirtualizedList from "./lookVirtualizedList";
import GroheVirtualizedList from "../../../grohe/groheNavigation/groheFeatures/groheVirtualizedList";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getCurrentLayout} from "../../../../appLayout";
import {featureGroupInterface} from "../../../../../interfaces/featureInterface";

const onScrollHandler = () => null;

const LookMainCategoryLoading = (props) => {

  const {lookViewType, contentHeight, isMobile, featureGroup, isWizard} = props;

  const layout = getCurrentLayout();

  const counts = featureGroup.counts ? featureGroup.counts[layout.type] : 0;

  if (counts > 0) {

    const content = IS_PRODUCT_JOURNEY ? (
      <div className={isMobile ? "lm-content--no-scroll" : "lm-content lm-content--no-scroll"}>
        <div className={"lm-features lm-features--type-" + lookViewType}>
          <GroheVirtualizedList loadingCount={counts} onScrollHandler={onScrollHandler}/>
        </div>
      </div>
    ) : (
      <LookVirtualizedList contentHeight={isWizard && !IS_PRODUCT_JOURNEY ? contentHeight + 64 : contentHeight}
                           onScrollHandler={onScrollHandler}
                           loadingCount={counts}
                           isMobile={isMobile}
                           updateLookCartItem={null}
                           lookViewType={lookViewType}/>
    )

    if (isWizard) {
      return content
    }

    return (
      <div className="lm-content lm-content--no-scroll">
        {content}
      </div>
    )
  }

  return (
    <div className="lm-content">
      <MaterialSpinner/>
    </div>
  )
};

LookMainCategoryLoading.propTypes = {
  contentHeight: PropTypes.number,
  featureGroup: PropTypes.shape(featureGroupInterface),
}

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {isMobile} = store.serverState;
  const {wizardActiveItem} = store.wizardState;

  return {
    isMobile,
    lookViewType,
    isWizard: !!wizardActiveItem
  };
};

export default connect(mapStateToProps)(LookMainCategoryLoading)
